export const benefitData = [
  {
    imgSrc:"./images/main/benefit/benefit01.png",
    title:"앱다운로드 안내",
  },
  {
    imgSrc:"./images/main/benefit/benefit02.png",
    title:"멤버쉽 안내",
  },
];